import React from "react";
import { useIntl } from "react-intl";
import SeoHead from "~/components/seo/SeoHead";

export default function ProjectsPageSeo() {
  const intl = useIntl();

  return (
    <SeoHead
      title={intl.formatMessage({ defaultMessage: "Local Government Innovation Projects – Govlaunch", id: "5mvmLR" })}
      description={intl.formatMessage({
        defaultMessage:
          "Search local government innovation projects and technology implementations from around the world.",
        id: "K1CZIZ",
      })}
    />
  );
}
